export enum OverrideRuleCriteria {
	EMPLOYEES = "employees",
	HQ_COUNTRY = "hq_country",
	INDUSTRY = "industry",
	SEGMENT = "segment",
	FOUNDED = "founded",
}

export enum OverrideRuleOperator {
	LESS_THAN = "lt",
	GREATER_THAN = "gt",
	BETWEEN = "between",
	EQUAL_TO = "eq",
	IS = "is",
	IS_NOT = "is_not",
}

export enum OverrideRuleAction {
	CEO = "ceo",
	PERSONA = "persona",
	CUSTOM = "custom",
}

export enum OverrideRuleLocation {
	ANYWHERE = "anywhere",
	HQ_COUNTRY = "hq_country",
	SPECIFIC = "specific",
}

export interface OverrideRule {
	id: number;
	criteria: OverrideRuleCriteria;
	operator: OverrideRuleOperator;
	value: string;
	valueTo?: string;
	action: OverrideRuleAction;
	actionDetail?: string;
	personaCategoryId?: number;
	location: OverrideRuleLocation;
	locationDetail?: string;
}

export const NUMERIC_CRITERIA = [OverrideRuleCriteria.EMPLOYEES, OverrideRuleCriteria.FOUNDED];

export const CATEGORICAL_CRITERIA = [
	OverrideRuleCriteria.HQ_COUNTRY,
	OverrideRuleCriteria.INDUSTRY,
	OverrideRuleCriteria.SEGMENT,
];

export const NUMERIC_OPERATORS = [
	OverrideRuleOperator.LESS_THAN,
	OverrideRuleOperator.GREATER_THAN,
	OverrideRuleOperator.BETWEEN,
	OverrideRuleOperator.EQUAL_TO,
];

export const CATEGORICAL_OPERATORS = [OverrideRuleOperator.IS, OverrideRuleOperator.IS_NOT];

export const createDefaultRule = (id: number): OverrideRule => ({
	id,
	criteria: OverrideRuleCriteria.EMPLOYEES,
	operator: OverrideRuleOperator.LESS_THAN,
	value: "",
	action: OverrideRuleAction.CEO,
	location: OverrideRuleLocation.ANYWHERE,
});
